// this weird syntax grabs the global object
const global = (0,eval)("this");

// Third party plugins needed on every page
// If they aren't explicitly attached to the global scope, they do on their own
import * as validate from "javascripts/sitebase/jquery/jquery-validate/1.19.3/jquery.validate.js"
import * as validateMethods from "javascripts/sitebase/jquery/jquery-validate/1.19.3/additional-methods"
import * as validateCustomMethods from "javascripts/sitebase/jquery-validate-custom-methods"
import * as Cookies from "javascripts/engineering360_shared/js-cookie"
import * as ErrorHandling from "javascripts/sitebase/es/error-handling"

import { setCookie, getCookie, deleteCookie } from "javascripts/sitebase/es/gs_cookies";
import { trackOmniClick, trackClick, exitTracking, buildOmnitureId } from "javascripts/sitebase/es/tracking";
import { assertDwToken } from "javascripts/engineering360_shared/es/tracking";
import { createSimpleModal, showSimpleModal, hideSimpleModal } from "javascripts/sitebase/es/simple-modal";

global.setCookie = setCookie
global.getCookie = getCookie
global.deleteCookie = deleteCookie
global.Cookies = Cookies

global.trackOmniClick = trackOmniClick
global.trackClick = trackClick
global.exitTracking = exitTracking
global.buildOmnitureId = buildOmnitureId
global.assertDwToken = assertDwToken

global.createSimpleModal = createSimpleModal
global.showSimpleModal = showSimpleModal
global.hideSimpleModal = hideSimpleModal
